<template>
  <el-row
    :gutter="5"
    style="height: 100%"
    class="content-form"
    v-loading="loading"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules2"
      :inline="true"
      label-width="90px"
    >
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title">
          添加普通工单信息
          <span class="info_btn">
            <i class="el-icon-minus"></i>
            <i class="el-icon-close" @click.stop="close"></i>
          </span>
        </div>
        <div class="clearfix">
          <el-button size="medium" plain>打印</el-button>
        </div>
      </el-col>
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">政府援助工单信息-客户信息</div>
        <div class="clearfix">
          <div class="fl add_infoItem">
            <div
              class="table-search clearfix"
              style="margin-bottom: 15px; color: red; font-size: 30px"
            >
              <el-form-item label="客户姓名" prop="name">
                <el-input
                  class="fl form-input"
                  v-model="form.name"
                  placeholder="请输入客户姓名"
                  @click.native="inputClickName"
                ></el-input> </el-form-item
              >*
              <div class="table-expand expandName" v-if="tableExpandName">
                <div class="table-search clearfix">
                  <div class="clearfix fl">
                    <label
                      style="font-size: 14px; color: black"
                      class="fl form-label"
                      >姓名</label
                    >
                    <el-input
                      class="fl form-input"
                      v-model="form1.name"
                    ></el-input>
                  </div>
                  <div class="clearfix fl">
                    <label
                      style="font-size: 14px; color: black"
                      class="fl form-label"
                      >地址</label
                    >
                    <el-input
                      class="fl form-input"
                      v-model="form1.address"
                    ></el-input>
                  </div>
                </div>
                <div class="table-search clearfix">
                  <div class="fl">
                    <label
                      style="font-size: 14px; color: black"
                      class="fl form-label"
                      >联系方式</label
                    >
                    <el-input
                      class="fl form-input"
                      v-model="form1.phone"
                    ></el-input>
                  </div>
                  <div class="fl">
                    <label
                      style="font-size: 14px; color: black"
                      class="fl form-label"
                      >用户类型</label
                    >
                    <el-select
                      class="fl form-input"
                      v-model="form1.type"
                      placeholder="请输入"
                    >
                      <el-option label="民政客户" value="6"></el-option>
                      <el-option label="D类客户" value="8"></el-option>
                    </el-select>
                  </div>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click.native="inputClickName"
                    >过滤</el-button
                  >
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekName"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="change"
                  :data="tableDatas"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="姓名"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="phone"
                    show-overflow-tooltip
                    label="联系方式"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="isFree"
                    :formatter="isFreeFormat"
                    show-overflow-tooltip
                    label="是否实体"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    :formatter="typeFormat"
                    show-overflow-tooltip
                    label="用户类型"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    show-overflow-tooltip
                    label="地址"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig1"
                  @currentPage="currentChange1"
                  @pageSize="pageSizeChange1"
                ></Paginationmini>
              </div>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="联系方式一" prop="phone">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="form.phone"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="联系地址" prop="address">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="form.address"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="主要服务人员" prop="groupName">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupName"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="从属服务人员一" prop="groupName">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupName"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="从属服务人员二" prop="groupName">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupName"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="志愿者" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="开始服务时间" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="服务时长" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="fl add_infoItem">
            <div
              class="table-search clearfix"
              style="margin-bottom: 15px; color: red; font-size: 30px"
            >
              <el-form-item label="联系人" prop="name">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="form.name"
                ></el-input> </el-form-item
              >*
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="联系方式二" prop="telphone">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="form.familyPhone"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="服务对象类型" prop="type">
                <el-select
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="form.type"
                  placeholder="请选择"
                >
                  <el-option label="民政客户" value="6"></el-option>
                  <el-option label="商业客户" value="7"></el-option>
                  <el-option label="残联客户" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="服务人员电话" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="免费订单" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="志愿者电话" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="结束服务时间" prop="groupAdress">
                <el-input
                  class="fl form-input"
                  readonly
                  unselectable="on"
                  v-model="groupAdress"
                ></el-input>
              </el-form-item>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="区域名称" prop="addressId">
                <el-select
                  class="fl form-input"
                  v-model="form.addressId"
                  @click.native="selectAddressName()"
                  @change="changeValues"
                  placeholder="请选择区域"
                >
                  <el-option
                    v-for="item in option4"
                    :label="item.addressName"
                    :key="item.id"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-col>

      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">政府援助工单信息-订购服务</div>
        <div class="clearfix">
          <div class="fl add_infoItem">
            <div
              class="table-search clearfix"
              style="margin-bottom: 15px; color: red; font-size: 30px"
            >
              <el-form-item
                style="font-size: 14px; color: black"
                label="服务种类"
                prop="firstType"
              >
                <el-select
                  class="fl form-input"
                  v-model="form.firstType"
                  @click.native="selectTypeName()"
                  @change="changeValue"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :label="item.typeName"
                    :key="item.id"
                    :value="item.id"
                  >
                  </el-option>
                </el-select> </el-form-item
              >*
            </div>
            <div class="addOrg-div clearfix">
              <el-form-item label="计划时间" prop="sertime">
                <el-date-picker
                  v-model="form.sertime"
                  type="datetime"
                  :picker-options="expireTimeOption"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm:ss"
                  placeholder="计划时间"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <div class="fl add_infoItem">
            <div
              class="addOrg-div clearfix"
              style="margin-bottom: 15px; color: red; font-size: 30px"
            >
              <el-form-item label="服务产品" prop="productname">
                <el-input
                  class="fl form-input"
                  v-model="form.productname"
                  placeholder="请输入"
                  @click.native="inputClickProduct"
                ></el-input> </el-form-item
              >*
              <div class="table-expand expandProduct" v-if="tableExpandProduct">
                <div class="table-search clearfix">
                  <div class="clearfix fl">
                    <label
                      style="font-size: 14px; color: black"
                      class="fl form-label"
                      >产品名称</label
                    >
                    <el-input
                      class="fl form-input"
                      v-model="form1.productName"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click.native="inputClickProduct"
                    >过滤</el-button
                  >
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekProduct"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changeProduct"
                  :data="tableData"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="productname"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="produce"
                    label="产品说明"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="referTime"
                    show-overflow-tooltip
                    label="参考工时"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="price"
                    show-overflow-tooltip
                    label="参考价格"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="firstName"
                    show-overflow-tooltip
                    label="类型一"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="secondName"
                    show-overflow-tooltip
                    label="类型二"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange2"
                  @pageSize="pageSizeChange2"
                ></Paginationmini>
              </div>
            </div>
            <div class="table-search clearfix" style="margin-bottom: 15px">
              <el-form-item label="频次" prop="number">
                <el-input
                  class="fl form-input"
                  v-model="form.number"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="clearfix">
          <div class="addOrg-div addOrder-div clearfix">
            <label class="fl form-label">产品说明</label>
            <el-input type="textarea" v-model="produce"></el-input>
          </div>
        </div>
        <div class="clearfix">
          <div class="addOrg-div addOrder-div clearfix">
            <label class="fl form-label">服务要求</label>
            <el-input type="textarea" v-model="form.serrequire"></el-input>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">政府援助工单信息-机构信息</div>
        <div class="clearfix">
          <div class="fl add_infoItem">
            <div class="addOrg-div clearfix">
              <label class="fl form-label">机构</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="form.servestationName"
                @click.native="inputClickStation"
                placeholder="请选择"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-delete"
                @click="cleanStateNames"
                v-if="showStateNames"
                >清空</el-button
              >
              <div class="table-expand" v-if="tableExpand">
                <div class="table-search">
                  <label class="fl form-label">名称</label>
                  <el-input
                    class="fl form-input"
                    v-model="stateNames"
                  ></el-input>
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click.native="inputClickStation"
                    >过滤</el-button
                  >
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekClick"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changeStation"
                  :data="tableData"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="statname"
                    label="站点名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    show-overflow-tooltip
                    label="地址"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange3"
                  @pageSize="pageSizeChange3"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <el-form-item label="主要服务人员" prop="servePersonName">
                <el-col :sp="24">
                  <el-input
                    class="fl form-input"
                    autocomplete="off"
                    readonly
                    v-model="form.servePersonName"
                    @click.native="inputPerson"
                    placeholder="请选择"
                  ></el-input>
                </el-col>
              </el-form-item>
              <div class="table-expand" v-if="tablePerson">
                <div class="table-search">
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekPerson"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changePerson"
                  :data="tableDatas"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="mobilePhone"
                    show-overflow-tooltip
                    label="手机号"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange4"
                  @pageSize="pageSizeChange4"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">从属服务人员一</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="otherServePersonName"
                @click.native="inputOtherPerson"
                placeholder="请选择"
              ></el-input>
              <div class="table-expand" v-if="tableOtherPerson">
                <div class="table-search">
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekOtherPerson"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changeOtherPerson"
                  :data="tableDatass"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="mobilePhone"
                    show-overflow-tooltip
                    label="手机号"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange5"
                  @pageSize="pageSizeChange5"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">从属服务人员二</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="form.otherServePersonNames"
                @click.native="inputOtherPersons"
                placeholder="请选择"
              ></el-input>
              <div class="table-expand" v-if="tableOtherPersons">
                <div class="table-search">
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekOtherPersons"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changeOtherPersons"
                  :data="tableDatasss"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="mobilePhone"
                    show-overflow-tooltip
                    label="手机号"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange6"
                  @pageSize="pageSizeChange6"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">志愿者</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="dropDownTreeText1"
                @click.native="inputClickzyz"
              ></el-input>
              <div class="table-expand" v-if="tableExpandzyz">
                <div class="table-search">
                  <label class="fl form-label">名称</label>
                  <el-input class="fl form-input" v-model="search"></el-input>
                  <el-button type="primary" size="small" icon="el-icon-search"
                    >过滤</el-button
                  >
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputcolseClickzyz"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  :data="tableData"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="date" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="number"
                    show-overflow-tooltip
                    label="手机"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig3"
                  @currentPage="currentChange1"
                  @pageSize="pageSizeChange1"
                ></Paginationmini>
              </div>
            </div>
          </div>
          <div class="fl add_infoItem">
            <div class="addOrg-div clearfix">
              <label class="fl form-label">加盟商</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="servestationNameJMS"
                @click.native="inputClickjms"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                icon="el-icon-delete"
                @click="cleanStateNamesJMS"
                v-if="showStateNamesJMS"
                >清空</el-button
              >
              <div class="table-expand" v-if="tableExpandjms">
                <div class="table-search">
                  <label class="fl form-label">名称</label>
                  <el-input
                    class="fl form-input"
                    v-model="searchStatnameJMS"
                  ></el-input>
                  <el-button type="primary" size="small" icon="el-icon-search"
                    >过滤</el-button
                  >
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputcloseClickjms"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  :data="tableDatajms"
                  @row-click="changeStationJMS"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="franchiseename"
                    label="加盟商"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="address"
                    show-overflow-tooltip
                    label="地址"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig7"
                  @currentPage="currentChange7"
                  @pageSize="pageSizeChange7"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <el-form-item label="加盟商主要服务人员" prop="serverpersonJMS">
                <el-col :sp="24">
                  <el-input
                    class="fl form-input"
                    autocomplete="off"
                    readonly
                    v-model="serverpersonJMS"
                    @click.native="inputPersonJMS"
                    placeholder="请选择"
                  ></el-input>
                </el-col>
              </el-form-item>
              <div class="table-expand" v-if="tablePersonJMS">
                <div class="table-search">
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekPersonJMS"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changePersonJms"
                  :data="tablePersonjms"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="mobilePhone"
                    show-overflow-tooltip
                    label="手机号"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig8"
                  @currentPage="currentChange8"
                  @pageSize="pageSizeChange8"
                ></Paginationmini>
              </div>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">加盟商从属服务人员</label>
              <el-input
                class="fl form-input"
                autocomplete="off"
                readonly
                v-model="otherServerpersonJMS"
                @click.native="inputOtherServerpersonJMS"
                placeholder="请选择"
              ></el-input>
              <div class="table-expand" v-if="tableOtherPersonsJms">
                <div class="table-search">
                  <el-button
                    size="medium"
                    type="danger"
                    @click.native="inputClosekOtherServerpersonJMS"
                    >关闭</el-button
                  >
                </div>
                <el-table
                  class="form-table"
                  @row-click="changeOtherServerpersonJMS"
                  :data="tableOtherPersonjms"
                  stripe
                  tooltip-effect="dark"
                  style="width: 100%"
                >
                  <el-table-column fixed prop="index" label="序号" width="50">
                  </el-table-column>
                  <el-table-column
                    prop="name"
                    label="名称"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="mobilePhone"
                    show-overflow-tooltip
                    label="手机号"
                  >
                  </el-table-column>
                </el-table>
                <Paginationmini
                  :pageConfig="pageConfig9"
                  @currentPage="currentChange9"
                  @pageSize="pageSizeChange9"
                ></Paginationmini>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">政府援助工单信息-服务坐席</div>
        <div class="clearfix">
          <div class="fl add_infoItem">
            <div class="addOrg-div clearfix">
              <label class="fl form-label">新建工单人</label>
              <el-input
                class="fl form-input"
                v-model="form.createSeatName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">派发工单人</label>
              <el-input
                class="fl form-input"
                v-model="form.distributeSeatName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">服务开始</label>
              <el-input
                class="fl form-input"
                v-model="form.timeStart"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">处理工单人</label>
              <el-input
                class="fl form-input"
                v-model="form.doneSeatName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">申请作废人</label>
              <el-input
                class="fl form-input"
                v-model="form.askCloseName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">作废工单人</label>
              <el-input
                class="fl form-input"
                v-model="form.closeSeatName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">回访工单人</label>
              <el-input
                class="fl form-input"
                v-model="form.callSeatName"
                readonly
                unselectable="on"
              ></el-input>
            </div>
          </div>
          <div class="fl add_infoItem">
            <div class="addOrg-div clearfix">
              <label class="fl form-label">新建工单</label>
              <el-input
                class="fl form-input"
                v-model="form.createTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">派发工单</label>
              <el-input
                class="fl form-input"
                v-model="form.distributeTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">服务结束</label>
              <el-input
                class="fl form-input"
                v-model="form.timeEnd"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">处理工单</label>
              <el-input
                class="fl form-input"
                v-model="form.doneTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">申请报废</label>
              <el-input
                class="fl form-input"
                v-model="form.askCloseTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">作废工单</label>
              <el-input
                class="fl form-input"
                v-model="form.closeTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
            <div class="addOrg-div clearfix">
              <label class="fl form-label">回访工单</label>
              <el-input
                class="fl form-input"
                v-model="form.callTime"
                readonly
                unselectable="on"
              ></el-input>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">APP用户反馈</div>
        <div class="clearfix">
          <div class="addOrg-div clearfix">
            <label class="fl form-label">语音评价</label>
            <el-input
              class="fl form-input"
              readonly
              unselectable="on"
              v-model="groupAdress"
            ></el-input>
          </div>
        </div>
      </el-col>
      <el-col :sm="24" class="add_infoDiv">
        <div class="add_info_title1">工作图片</div>
        <div class="clearfix">
          <div class="addOrg-div clearfix">
            <label class="fl form-label">工作开始</label>
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </div>
          <div class="addOrg-div clearfix">
            <label class="fl form-label">工作结束</label>
            <el-upload
              class="upload-demo"
              action="https://jsonplaceholder.typicode.com/posts/"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :file-list="fileList2"
              list-type="picture"
            >
              <el-button size="small" type="primary">选择文件</el-button>
            </el-upload>
          </div>
        </div>
        <div class="clearfix bottom-btn">
          <el-button type="primary" @click="saveBtn('form')">保存</el-button>
          <el-button type="primary" @click="paifa('form')">派发</el-button>
        </div>
      </el-col>
    </el-form>
  </el-row>
</template>

<script>
import { metaDataMgrDao } from "@/api/dao.js"
import Paginationmini from "../add/pagination-mini"
export default {
  props: ["id"],
  data: function () {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("客户姓名不能为空"))
      } else {
        callback()
      }
    }
    var checkFirstType = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("服务种类不能为空"))
      } else {
        callback()
      }
    }
    var checkProductName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("服务产品不能为空"))
      } else {
        callback()
      }
    }
    return {
      expireTimeOption: {
        disabledDate(date) {
          //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() <= Date.now()
        },
      },
      counter: this.id,
      tableExpand: false,
      tableExpandjms: false,
      tableExpandzyz: false,
      tableExpandName: false,
      tableExpandProduct: false,
      loading: false,
      tableData: [],
      tableDatas: [],
      fileList2: [],
      tableDatass: [],
      option4: [],
      tableDatasss: [],
      options: [],
      belongAddressId: "",
      belongProvinceId: "",
      belongAddressLevel: "",
      parentId: "",
      username: "",
      produce: "",
      stateNames: "",
      tablePerson: false,
      tableOtherPerson: false,
      tableOtherPersons: false,
      tableOtherPersonsJms: false,
      showStateNames: false,
      tablePersonJMS: false,
      showStateNamesJMS: false,
      servestationNameJMS: "",
      searchStatnameJMS: "",
      serverpersonJMS: "",
      otherServerpersonJMS: "",
      servestationIdJMS: "",
      servePersonIdJMS: "",
      otherServePersonName: "",
      form: {
        servestationId: "",
        servestationName: "",
        servePersonName: "",
        otherservePersonName: "",
        otherservePersonNames: "",
        number: "",
        serrequire: "",
        productname: "",
        addressId: "",
        name: "",
        address: "",
        type: "",
        phone: "",
        familyPhone: "",
        firstTypeId: "",
        productNameId: "",
        customerId: "",
        price: "",
        sertime: "",
        createSeatName: "",
        distributeSeatName: "",
        timeStart: "",
        doneSeatName: "",
        askCloseName: "",
        closeSeatName: "",
        callSeatName: "",
        createTime: "",
        distributeTime: "",
        timeEnd: "",
        doneTime: "",
        askCloseTime: "",
        closeTime: "",
        callTime: "",
      },
      shiId: "",
      quId: "",
      jdId: "",
      sqId: "",
      form1: {
        name: "",
        address: "",
        type: "6",
        phone: "",
        productName: "",
        productNameId: "",
        customerId: "",
        states: "2",
      },
      rules2: {
        name: [{ validator: checkName, trigger: "blur" }],
        firstType: [{ validator: checkFirstType, trigger: "blur" }],
        productname: [{ validator: checkProductName, trigger: "blur" }],
      },
      pageConfig3: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
      pageConfig1: {
        pageSize: 6,
        total: 0,
        pageNo: 1,
      },
    }
  },
  methods: {
    selectAddressName() {
      if (this.belongAddressId != null && this.belongAddressId != "") {
        if (this.belongAddressLevel == "1") {
          var formData = new FormData()
          formData.append("belongAddressLevel", "2")
          formData.append("parentId", this.belongAddressId)
          metaDataMgrDao.findCityInfo(formData).then((resp) => {
            if (resp.code == "200") {
              this.option4 = []
              console.log(resp)
              let list = resp.content.list
              this.option4 = this.option4.concat(list)
            }
            this.tableLoading = false
            console.log(resp)
          })
        } else {
          var formData = new FormData()
          formData.append("id", this.belongAddressId)
          metaDataMgrDao.findCityInfoById(formData).then((resp) => {
            if (resp.code == "200") {
              this.option4 = []
              console.log(resp)
              let list = resp.content
              this.option4 = this.option4.concat(list)
            }
            this.tableLoading = false
            console.log(resp)
          })
        }
      } else {
        var formData = new FormData()
        formData.append("belongAddressLevel", "2")
        metaDataMgrDao.findCityInfo(formData).then((resp) => {
          if (resp.code == "200") {
            this.option4 = []
            console.log(resp)
            let list = resp.content.list
            this.option4 = this.option4.concat(list)
          }
          this.tableLoading = false
          console.log(resp)
        })
      }
    },
    changeValues(value) {
      this.form.addressId = value
      console.log(value)
      var formData = new FormData()
      formData.append("id", this.form.addressId)
      metaDataMgrDao.findCityInfoById(formData).then((resp) => {
        if (resp.code == "200") {
          let list = resp.content
          this.parentId = list.parentId
          console.log(list)
        }
      })
    },
    typeFormat(row, column) {
      if (row.type === 7) {
        return "商业客户"
      } else if (row.type === 6) {
        return "民政客户"
      } else if (row.type === 4) {
        return "老干客户"
      } else if (row.type === 3) {
        return "残联客户"
      }
    },
    isFreeFormat(row, column) {
      if (row.isFree === "0") {
        return "否"
      } else if (row.isFree === "1") {
        return "是"
      }
    },
    customerById(id) {
      console.log(id)
      this.tableExpandName = false
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.findCustomersId(formData).then((resp) => {
        if (resp.code == "200") {
          console.log(resp)
          let obj = resp.content
          obj.type = obj.type.toString()
          this.form = obj
        }
        this.form.customerId = id
        this.form1.customerId = id
        this.tableLoading = false
        console.log(resp)
      })
    },
    saveBtn(formName) {
      this.cleanStateNames()
      this.cleanStateNamesJMS()
      // if(this.servestationIdJMS != null && this.servestationIdJMS != ''){
      //     this.$message("保存时不需要机构信息！");

      // }
      // if(this.form.servestationId != null && this.form.servestationId != ''){
      //     this.$message("保存时不需要机构信息！");
      // }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var formData = new FormData()
          formData.append("serviceType", this.form.firstTypeId)
          formData.append("serrequire", this.form.serrequire)
          formData.append("serveProduct", this.form.productNameId)
          formData.append("customer", this.form.customerId)
          formData.append("price", this.form.price)
          formData.append("sertime", this.form.sertime)
          formData.append("createSeatName", this.username)
          formData.append("number", this.form.number)
          if (this.belongAddressId != null && this.belongAddressId != "") {
            formData.append("belongAddressId", this.belongAddressId)
          } else {
            formData.append("belongAddressId", this.form.addressId)
          }
          if (this.belongProvinceId != null && this.belongProvinceId != "") {
            formData.append("belongProvinceId", this.belongProvinceId)
          } else {
            formData.append("belongProvinceId", this.parentId)
          }
          console.log(formData)
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            target: document.querySelector(".div1"),
          })
          setTimeout(() => {
            loading.close()
          }, 2000)
          metaDataMgrDao.addServicePGD(formData).then((resp) => {
            if (resp.code == "200") {
              this.$alert("提交成功", "提交结果", {
                confirmButtonText: "确定",
                type: "success",
                callback: (action) => {
                  this.loading = false
                  this.$emit("closeAddOrg", true)
                },
              })
            } else {
              this.$alert("提交失败", "提交结果", {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {
                  this.loading = false
                  this.$emit("closeAddOrg", true)
                },
              })
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    close() {
      this.$emit("closeAddOrg", true)
    },
    paifa(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var formData = new FormData()
          formData.append("serviceType", this.form.firstTypeId)
          formData.append("serrequire", this.form.serrequire)
          formData.append("serveProduct", this.form.productNameId)
          formData.append("customer", this.form.customerId)
          formData.append("price", this.form.price)
          formData.append("sertime", this.form.sertime)
          formData.append("createSeatName", this.username)
          formData.append("number", this.form.number)
          if (this.belongAddressId != null && this.belongAddressId != "") {
            formData.append("belongAddressId", this.belongAddressId)
          } else {
            formData.append("belongAddressId", this.form.addressId)
          }
          if (this.belongProvinceId != null && this.belongProvinceId != "") {
            formData.append("belongProvinceId", this.belongProvinceId)
          } else {
            formData.append("belongProvinceId", this.parentId)
          }

          formData.append("id", this.counter)
          formData.append("states", 1)
          formData.append("appStates", 2)
          if (this.servestationIdJMS != null && this.servestationIdJMS != "") {
            formData.append("serveStation", this.servestationIdJMS)
            if (this.servePersonIdJMS != null && this.servePersonIdJMS != "") {
              formData.append("servePersonID", this.servePersonIdJMS)
            } else {
              this.$message("主要服务人员不可为空！！！")
              return
            }
            if (
              this.otherServePersonIdJMS != null &&
              this.otherServePersonIdJMS != ""
            ) {
              formData.append("otherservePersonID", this.otherServePersonIdJMS)
            }
            formData.append("type", 2)
            this.form.servePersonId = this.servePersonIdJMS
          } else {
            if (
              this.form.servestationId == null ||
              this.form.servestationId == ""
            ) {
              this.$message("机构和加盟商至少选填一项！！！")
              return
            } else {
              formData.append("serveStation", this.form.servestationId)
            }
            if (
              this.form.servePersonId != null &&
              this.form.servePersonId != ""
            ) {
              formData.append("servePersonID", this.form.servePersonId)
            } else {
              this.$message("主要服务人员不可为空！！！")
              return
            }
            if (
              this.form.otherServePersonId != null &&
              this.form.otherServePersonId != ""
            ) {
              formData.append(
                "otherservePersonID",
                this.form.otherServePersonId
              )
            }
            if (
              this.form.otherServePersonIds != null &&
              this.form.otherServePersonIds != ""
            ) {
              formData.append(
                "otherservePersonIDs",
                this.form.otherServePersonIds
              )
            }

            formData.append("type", 1)
          }
          formData.append("distributeSeatName", sessionStorage.getItem("name"))
          console.log(formData)
          const loading = this.$loading({
            lock: true,
            text: "Loading",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
            target: document.querySelector(".div1"),
          })
          setTimeout(() => {
            loading.close()
          }, 2000)
          metaDataMgrDao.insertAndDistribute(formData).then((resp) => {
            if (resp.code == "200") {
              console.log(resp.content.id)
              this.$alert("提交成功", "提交结果", {
                confirmButtonText: "确定",
                type: "success",
                callback: (action) => {
                  this.loading = false
                  //sessionStorage.setItem("paifa",resp.content.id);
                  this.$router.push({ path: "/works_order1" })
                },
              })
            } else {
              this.$alert("提交失败", "提交结果", {
                confirmButtonText: "确定",
                type: "warning",
                callback: (action) => {
                  this.loading = false
                  this.$emit("closeAddOrg", true)
                },
              })
            }
          })
        } else {
          console.log("error submit!!")
          return false
        }
      })
    },
    handleRemove() {},
    handlePreview() {},
    inputClick() {
      this.tableExpand = true
    },
    inputClickjms() {
      this.tableExpandjms = true
    },
    inputClickzyz() {
      this.tableExpandzyz = true
    },
    inputClickName() {
      this.tableExpandName = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig1.pageNo)
      formData.append("pageSize", this.pageConfig1.pageSize)
      formData.append("name", this.form1.name)
      formData.append("phone", this.form1.phone)
      formData.append("address", this.form1.address)
      formData.append("type", this.form1.type)
      formData.append("states", this.form1.states)
      if (
        sessionStorage.getItem("zfshi") != "null" &&
        sessionStorage.getItem("zfshi") != ""
      ) {
        formData.append("city", this.shiId)
        if (
          sessionStorage.getItem("zfqu") != "null" &&
          sessionStorage.getItem("zfqu") != ""
        ) {
          formData.append("zone", this.quId)
        }
        if (
          sessionStorage.getItem("zfjd") != "null" &&
          sessionStorage.getItem("zfjd") != ""
        ) {
          formData.append("street", this.jdId)
        }
        if (
          sessionStorage.getItem("zfsq") != "null" &&
          sessionStorage.getItem("zfsq") != ""
        ) {
          formData.append("shequ", this.sqId)
        }
      }
      formData.append("isFree", 1)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.getCustomers(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableDatas = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig1.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig1.total = resp.content.count
            this.tableDatas = this.tableDatas.concat(list)
          } else {
            console.log(resp)
            this.tableDatas = []
            var count = 0
            this.pageConfig1.total = count
          }
        } else {
          this.tableDatas = this.tableDatas.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    inputClosekName() {
      this.tableExpandName = false
    },
    change(row) {
      this.tableExpandName = false
      var formData = new FormData()
      formData.append("id", row.id)
      metaDataMgrDao.findCustomersId(formData).then((resp) => {
        if (resp.code == "200") {
          console.log(resp)
          let obj = resp.content
          obj.type = obj.type.toString()
          this.form.name = obj.name
          this.form.phone = obj.phone
          this.form.familyPhone = obj.familyPhone
          this.form.type = obj.type
          this.form.address = obj.address
        }
        this.form.customerId = row.id
        this.form1.customerId = row.id
        this.tableLoading = false
        console.log(resp)
      })
    },
    //服务种类查询
    selectTypeName() {
      var formData = new FormData()
      formData.append("typeLevel", "0")
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServeType(formData).then((resp) => {
        if (resp.code == "200") {
          this.options = []
          console.log(resp)
          let list = resp.content

          this.options = this.options.concat(list)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    changeValue(value) {
      this.form.firstTypeId = value
    },
    //服务产品下拉列表

    inputClickProduct() {
      var firstTypeId = this.form.firstTypeId
      this.tableExpandProduct = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("firstType", firstTypeId)
      formData.append("productName", this.form1.productName)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.getServeProduct(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableData = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableData = this.tableData.concat(list)
          } else {
            console.log(resp)
            this.tableData = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableData = this.tableData.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    inputClosekProduct() {
      this.tableExpandProduct = false
    },
    changeProduct(row) {
      this.tableExpandProduct = false
      var formData = new FormData()
      formData.append("id", row.id)
      metaDataMgrDao.getServeProductId(formData).then((resp) => {
        if (resp.code == "200") {
          console.log(resp)
          let obj = resp.content
          this.form.price = obj.price
          this.form.productname = obj.productname
          console.log(obj.productname)
          this.produce = obj.produce
        }
        this.form.productNameId = row.id
        this.form1.productNameId = row.id
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange1(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputClickName()
    },
    pageSizeChange1(size) {
      this.pageConfig3.pageSize = size
    },
    currentChange2(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputClickProduct()
    },
    pageSizeChange2(size) {
      this.pageConfig3.pageSize = size
    },

    inputClickStation() {
      this.tableExpand = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("statname", this.stateNames)
      formData.append("type", 0)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServeStation(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableData = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableData = this.tableData.concat(list)
          } else {
            console.log(resp)
            this.tableData = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableData = this.tableData.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange3(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputClickStation()
    },
    pageSizeChange3(size) {
      this.pageConfig3.pageSize = size
    },
    cleanStateNames() {
      this.form.servestationName = ""
      this.showStateNames = false
      this.form.servestationId = "id"
      this.form.servePersonName = ""
      this.otherServePersonName = ""
      this.form.otherServePersonNames = ""
      this.form.otherservePersonId = ""
      this.form.otherservePersonIds = ""
      this.tableLoading = true
    },

    changeStation(row) {
      console.log("----------row参数：" + row.id + "---:" + row.index)
      var id = row.id
      this.tableExpand = false
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.findServestationById(formData).then((resp) => {
        if (resp.code == "200") {
          console.log(resp)
          let obj = resp.content
          this.form.servestationName = obj.statname
          this.showStateNames = true
        }
        this.form.servestationId = id
        this.form.servePersonName = ""
        this.form.otherservePersonName = ""
        this.tableLoading = false
        console.log(resp)
      })
    },

    inputClosekClick() {
      this.tableExpand = false
    },
    inputPerson() {
      this.tablePerson = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("servestationId", this.form.servestationId)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServePersonByServestationId(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableDatas = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableDatas = this.tableDatas.concat(list)
          } else {
            console.log(resp)
            this.tableDatas = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableDatas = this.tableDatas.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange4(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputPerson()
    },
    pageSizeChange4(size) {
      this.pageConfig3.pageSize = size
    },
    changePerson(row) {
      var id = row.id
      this.tablePerson = false
      var formData = new FormData()
      formData.append("id", id)
      formData.append("servetypeId", this.form.firstTypeId)
      metaDataMgrDao.findServePersonIds(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let obj = resp.content
            this.form.servePersonName = obj.name
          } else {
            this.$message(resp.message)
          }
        } else {
          this.$message(resp.message)
        }
        this.form.servePersonId = id
        console.log(resp)
      })
    },
    inputClosekPerson() {
      this.tablePerson = false
    },
    inputOtherPerson() {
      this.tableOtherPerson = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("servestationId", this.form.servestationId)

      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServePersonByServestationId(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableDatass = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableDatass = this.tableDatass.concat(list)
          } else {
            console.log(resp)
            this.tableDatass = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableDatass = this.tableDatass.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange5(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputOtherPerson()
    },
    pageSizeChange5(size) {
      this.pageConfig3.pageSize = size
    },

    inputClosekOtherPerson() {
      this.tableOtherPerson = false
    },
    changeOtherPerson(row) {
      var id = row.id
      this.tableOtherPerson = false
      var formData = new FormData()
      formData.append("id", id)
      formData.append("servetypeId", this.form.firstTypeId)
      metaDataMgrDao.findServePersonIds(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let obj = resp.content
            this.otherServePersonName = obj.name
            this.tableOtherPerson = false
          } else {
            this.$message(resp.message)
          }
        } else {
          this.$message(resp.message)
        }
        this.form.otherServePersonId = id
        this.tableLoading = false
        console.log(resp)
      })
    },
    inputOtherPersons() {
      this.tableOtherPersons = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("servestationId", this.form.servestationId)

      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServePersonByServestationId(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableDatasss = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableDatasss = this.tableDatasss.concat(list)
          } else {
            console.log(resp)
            this.tableDatasss = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableDatasss = this.tableDatasss.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange6(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputOtherPersons()
    },
    pageSizeChange6(size) {
      this.pageConfig3.pageSize = size
    },
    inputClosekOtherPersons() {
      this.tableOtherPersons = false
    },
    changeOtherPersons(row) {
      var id = row.id
      this.tableOtherPerson = false
      var formData = new FormData()
      formData.append("id", id)
      formData.append("servetypeId", this.form.firstTypeId)
      metaDataMgrDao.findServePersonIds(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let obj = resp.content
            this.form.otherServePersonNames = obj.name
            this.tableOtherPersons = false
          } else {
            this.$message(resp.message)
          }
        } else {
          this.$message(resp.message)
        }
        this.form.otherServePersonIds = id
        this.tableLoading = false
        console.log(resp)
      })
    },
    // 查询加盟商
    inputClickjms() {
      this.tableExpandjms = true
      this.tableLoading = true
      this.searchStatnameJMS = ""
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("statname", this.searchStatnameJMS)
      formData.append("type", 1)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.getFranchiser(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableDatajms = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableDatajms = this.tableDatajms.concat(list)
          } else {
            console.log(resp)
            this.tableDatajms = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableDatajms = this.tableDatajms.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange7(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputClickjms()
    },
    pageSizeChange7(size) {
      this.pageConfig3.pageSize = size
    },
    //选中加盟商
    changeStationJMS(row) {
      var id = row.id
      this.tableExpandjms = false
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.findFranchiserId(formData).then((resp) => {
        if (resp.code == "200") {
          console.log(resp)
          let obj = resp.content
          this.servestationNameJMS = obj.franchiseename
          this.servestationIdJMS = id
          this.showStateNamesJMS = true
        }
        this.serverpersonJMS = ""
        this.servePersonIdJMS = ""

        this.otherServerpersonJMS = ""
        this.otherServePersonIdJMS = ""
        this.tableLoading = false
        console.log(resp)
      })
    },
    //清除加盟商
    cleanStateNamesJMS() {
      this.showStateNamesJMS = false
      this.searchStatnameJMS = ""

      this.servestationIdJMS = ""
      this.servestationNameJMS = ""
      this.servePersonIdJMS = ""
      this.serverpersonJMS = ""
      this.otherServerpersonJMS = ""
      this.otherServePersonIdJMS = ""

      this.tableLoading = true
    },
    //选择加盟商服务人员
    inputPersonJMS() {
      this.tablePersonJMS = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("servestationId", this.servestationIdJMS)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServePersonByServestationId(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tablePersonjms = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tablePersonjms = this.tableDatas.concat(list)
          } else {
            console.log(resp)
            this.tablePersonjms = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tablePersonjms = this.tablePersonjms.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange8(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputPersonJMS()
    },
    pageSizeChange8(size) {
      this.pageConfig3.pageSize = size
    },
    changePersonJms(row) {
      var id = row.id
      this.tablePersonJMS = false
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.findServePersonIds(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let obj = resp.content
            this.serverpersonJMS = obj.name
          } else {
            this.$message(resp.message)
          }
        } else {
          this.$message(resp.message)
        }
        this.servePersonIdJMS = id
        console.log(resp)
      })
    },
    inputOtherServerpersonJMS() {
      this.tableOtherPersonsJms = true
      this.tableLoading = true
      var formData = new FormData()
      formData.append("pageNo", this.pageConfig3.pageNo)
      formData.append("pageSize", this.pageConfig3.pageSize)
      formData.append("servestationId", this.servestationIdJMS)
      if (this.belongAddressLevel == "1") {
        formData.append("belongProvinceId", this.belongProvinceId)
      } else {
        formData.append("belongAddressId", this.belongAddressId)
      }
      metaDataMgrDao.findServePersonByServestationId(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            this.tableOtherPersonjms = []
            let list = resp.content.list
            let currentPageNo = resp.content.pageNo
            let currentFirstIndex =
              (currentPageNo - 1) * this.pageConfig3.pageSize + 1
            for (let o of list) {
              o.index = currentFirstIndex
              o.key = currentFirstIndex
              currentFirstIndex++
            }
            this.pageConfig3.total = resp.content.count
            this.tableOtherPersonjms = this.tableDatas.concat(list)
          } else {
            console.log(resp)
            this.tableOtherPersonjms = []
            var count = 0
            this.pageConfig3.total = count
          }
        } else {
          this.tableOtherPersonjms = this.tableOtherPersonjms.concat(null)
        }
        this.tableLoading = false
        console.log(resp)
      })
    },
    currentChange9(currentPage) {
      this.pageConfig3.pageNo = currentPage
      this.inputOtherServerpersonJMS()
    },
    pageSizeChange9(size) {
      this.pageConfig3.pageSize = size
    },
    currentChange1(currentPage) {
      this.pageConfig1.pageNo = currentPage
      this.inputClickName()
    },
    pageSizeChange1(size) {
      this.pageConfig1.pageSize = size
    },
    changeOtherServerpersonJMS(row) {
      var id = row.id
      this.tableOtherPersonsJms = false
      var formData = new FormData()
      formData.append("id", id)
      metaDataMgrDao.findServePersonIds(formData).then((resp) => {
        if (resp.code == "200") {
          if (resp.content != null) {
            console.log(resp)
            let obj = resp.content
            this.otherServerpersonJMS = obj.name
          } else {
            this.$message(resp.message)
          }
        } else {
          this.$message(resp.message)
        }
        this.otherServePersonIdJMS = id
        console.log(resp)
      })
    },
    inputClosekPersonJMS() {
      this.tablePersonJMS = false
    },
    inputClosekOtherServerpersonJMS() {
      this.tableOtherPersonsJms = false
    },
    inputcloseClickjms() {
      this.tableExpandjms = false
    },
    inputcolseClickzyz() {
      this.tableExpandzyz = false
    },
  },
  mounted: function () {
    if (
      sessionStorage.getItem("zfshiId") != "null" &&
      sessionStorage.getItem("zfshiId") != ""
    ) {
      this.shiId = sessionStorage.getItem("zfshiId")
    }
    if (
      sessionStorage.getItem("zfquId") != "null" &&
      sessionStorage.getItem("zfquId") != ""
    ) {
      this.quId = sessionStorage.getItem("zfquId")
    }
    if (
      sessionStorage.getItem("zfjdId") != "null" &&
      sessionStorage.getItem("zfjdId") != ""
    ) {
      this.jdId = sessionStorage.getItem("zfjdId")
    }
    if (
      sessionStorage.getItem("zfsqId") != "null" &&
      sessionStorage.getItem("zfsqId") != ""
    ) {
      this.sqId = sessionStorage.getItem("zfsqId")
    }
    if (sessionStorage.getItem("user")) {
      var a = sessionStorage.getItem("user")
      this.belongAddressId = a
      console.log(this.belongAddressId)
    }
    if (sessionStorage.getItem("name")) {
      var name = sessionStorage.getItem("name")
      this.username = name
      console.log(this.belongAddressId)
    }
    if (sessionStorage.getItem("belongAddressLevel")) {
      var a = sessionStorage.getItem("belongAddressLevel")
      this.belongAddressLevel = a
      console.log(this.belongAddressLevel)
    }
    if (sessionStorage.getItem("belongProvinceId")) {
      var a = sessionStorage.getItem("belongProvinceId")
      this.belongProvinceId = a
      console.log(this.belongProvinceId)
    }
    setTimeout(() => {
      if (this.counter) {
        this.customerById(this.counter)
      }
    }, 0)
  },
  components: { Paginationmini },
}
</script>

<style lang="less">
.add_infoItem {
  width: 50%;
}
.addOrg-div {
  margin-bottom: 10px;
  .form-label {
    width: 128px;
    display: inline-block;
    text-align: right;
    line-height: 30px;
    margin-right: 10px;
  }
  .form-input {
    width: 68%;
    position: relative;
  }
}
.bottom-btn {
  text-align: center;
  margin-top: 30px;
}
.addOrder-div {
  .el-textarea {
    width: 80%;
  }
}
.table-expand {
  position: absolute;
  z-index: 100;
  width: 33%;
  margin-top: 29px;
  margin-left: 137px;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 5px;
  .table-search {
    padding-top: 10px;
    display: flex;
    .form-label {
      width: 60px;
    }
    .form-input {
      width: 50%;
    }
  }
  .el-table {
    margin-top: 10px;
  }
}
.expandName {
  width: 50%;
}
</style>
